import React from 'react';
import { Route, Routes } from 'react-router-dom';

import { urlBuilder } from '@/shared/utils/url-builder';
import { HeaderProcess } from '@/widgets/Header';
import { Footer } from '@/widgets/Footer';
import { RedirectLazy } from '@/pages/Redirect';
import { PaymentPageProcess } from '@/pages/PaymentPage';
import { Payment3dsPageLazy } from '@/pages/Payment3dsPage';
import { CompletedLazy } from '@/pages/Completed';
import styles from '@/static/styles/scss/page.scss';


export const App = () => {
    return (
        <div className={ styles.page }>
            <HeaderProcess/>

            <Routes>
                <Route
                    path={ urlBuilder('initPayment/:pathParam?') }
                    element={ <PaymentPageProcess /> }
                />

                <Route
                    path={ urlBuilder('init3ds/:pathParam?') }
                    element={ <Payment3dsPageLazy/> }
                />

                <Route
                    path={ urlBuilder('completePayment/:pathParam?') }
                    element={ <RedirectLazy/> }
                />

                <Route
                    path={ urlBuilder('completed/:pathParam?') }
                    element={ <CompletedLazy/> }
                />
            </Routes>

            <Footer/>
        </div>
    );
};
